export function formatNumberWithCommas(number, decimalPoints = 2) {
  return parseFloat(number || 0).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimalPoints,
  });
}
